var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('b-btn',{attrs:{"href":_vm.model.promotionUrl,"target":"_blank","variant":"secondary","size":"sm","title":"Preview"}},[_c('i',{staticClass:"fas fa-fw fa-external-link-alt"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }